const Loader = ({
  text = "Memuat data...",
  size = "md",
  fullPage = false,
  inline = false,
}) => {
  const classes = [
    "ui-loader",
    `ui-loader--${size}`,
    fullPage ? "ui-loader--fullpage" : "",
    inline ? "ui-loader--inline" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes} role="status" aria-live="polite">
      <div className="ui-loader__spinner"></div>
      {text && <p className="ui-loader__text">{text}</p>}
    </div>
  );
};

export default Loader;